export default __webpack_public_path__ + "static/media/vi_discapacidad.adf2492a.mp4";